export let mock_trendreport = {
};



// WEBPACK FOOTER //
// ./src/mocks/trendreport/index.ts